import React from 'react';
export function ContactSection() {
  return <section id="contact" className="py-32 md:py-48 border-t border-gray-100 max-w-6xl mx-auto px-6" data-id="element-14">
      <div className="max-w-3xl" data-id="element-15">
        <div className="mb-20 py-12 border-t border-b border-gray-200" data-id="element-16">
          <p className="text-2xl md:text-3xl font-light text-black leading-relaxed text-center" data-id="element-17">
            Speed without discipline creates chaos. Discipline without speed
            creates drift. This work exists to prevent both.
          </p>
        </div>

        <h2 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-4" data-id="element-18">
          Contact
        </h2>
        <h3 className="text-5xl md:text-6xl font-light text-black mb-12 tracking-tight" data-id="element-19">
          Let's talk.
        </h3>
        <p className="text-xl text-gray-600 mb-16 max-w-xl leading-relaxed" data-id="element-20">
          No sales pitch. Just a conversation to see if I can help clear the
          path in the next 30–60 days.
        </p>

        <div className="flex flex-col sm:flex-row gap-6" data-id="element-21">
          <a href="mailto:bcgwynn@gmail.com" className="inline-flex items-center justify-center px-10 py-4 bg-black text-white text-sm font-medium tracking-wide hover:bg-gray-800 transition-colors" data-id="element-22">
            Email me
          </a>
          <a href="https://calendly.com/brittneygwynn" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-10 py-4 border border-gray-200 text-black text-sm font-medium tracking-wide hover:border-black transition-colors" data-id="element-23">
            Book a time
          </a>
        </div>
      </div>
    </section>;
}